import { Outlet } from 'react-router';

import { Header } from '@/components/sections/Header';
import { Footer } from '@/components/sections/Footer';
import { BookDemoProvider } from '@/components/ui/book-demo-dialog';
import { PageMetadata } from './PageMetadata';

export function Layout() {
  return (
    <BookDemoProvider>
      <div className="relative min-h-screen overflow-x-clip bg-white text-ink-900 antialiased">
        <PageMetadata />
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </BookDemoProvider>
  );
}
